import { apiClient } from '@/lib/api-client';
import { Warehouse, WarehouseRequest, WarehousePageResponse } from '../types';

export const warehouseApi = {
    getAll: async (page: number, size: number): Promise<WarehousePageResponse> => {
        const response = await apiClient.get(`/warehouses?page=${page}&size=${size}`);
        return response.data.data;
    },

    getById: async (id: number): Promise<Warehouse> => {
        const response = await apiClient.get(`/warehouses/${id}`);
        return response.data.data;
    },

    create: async (data: WarehouseRequest): Promise<Warehouse> => {
        const response = await apiClient.post('/warehouses', data);
        return response.data.data;
    },

    update: async (id: number, data: WarehouseRequest): Promise<Warehouse> => {
        const response = await apiClient.put(`/warehouses/${id}`, data);
        return response.data.data;
    },

    delete: async (id: number): Promise<void> => {
        await apiClient.delete(`/warehouses/${id}`);
    },
};
